import { apiService } from './api';

export interface DashboardMetrics {
  totalOrders: number;
  activeOrders: number;
  totalPlacements: number;
  completedPlacements: number;
  livePlacements: number;
  readyToPublishPlacements: number;
  totalRevenue: number;
  monthlyRevenue: number;
  weeklyTrends: {
    placements: number;
    completedPlacements: number;
    readyToPublish: number;
  };
  placementsByStatus: Array<{
    status: string;
    count: number;
  }>;
  recentActivity: Array<{
    id: string;
    type: string;
    description: string;
    timestamp: string;
  }>;
  slaBreaches: Array<{
    id: string;
    orderNumber: string;
    clientName: string;
    daysOverdue: number;
    stage: string;
  }>;
  liveLinkMonitoringSummary?: {
    total: number;
    ok: number;
    errors: number;
    timeout: number;
    pending: number;
    errorTotal: number;
    live: number;
    removed: number;
    checking: number;
    liveLinks200Count: number;
    liveLinks200Percentage: number;
  };
  linkHealthSummary?: {
    total: number;
    live: number;
    removed: number;
    checking: number;
  };
  topCategories?: Array<{
    category: string;
    count: number;
  }>;
}

export type DashboardRange = 'all' | '7d' | 'month' | 'lastMonth' | 'year';

class DashboardService {
  async getDashboardMetrics(range: DashboardRange = 'all'): Promise<DashboardMetrics> {
    const url = range && range !== 'all' ? `/reports/dashboard?range=${range}` : '/reports/dashboard';
    const response = await apiService.get<{ success: boolean; data: DashboardMetrics }>(url);
    return response.data;
  }
}

export const dashboardService = new DashboardService();
